import React from 'react'
import style from '@aytm/app/swidget/base/questions/Ecommerce/Amazon/amazon.module.scss'
import EmptyLink from '@aytm/app/swidget/base/components/EmptyLink.tsx'
import useSurveyLocale from '@aytm/app/swidget/base/modules/locale/useSurveyLocale'

interface IFooterProps {
  scrollTop: () => void
}
const Footer = ({ scrollTop }: IFooterProps) => {
  const { t } = useSurveyLocale()
  return (
    <footer>
      <div className={`${style.navMain} ${style.footer}`}>
        <div className={style.backToTop} onClick={scrollTop}>
          {t('questions', 'ec', 'amazon', 'top')}
        </div>
        <div className={style.links}>
          <div className={style.column}>
            <div>{t('questions', 'ec', 'amazon', 'knowUs')}</div>
            <EmptyLink>
              <span>{t('questions', 'ec', 'amazon', 'careers')}</span>
            </EmptyLink>
            <EmptyLink>
              <span>{t('questions', 'ec', 'amazon', 'newsletter')}</span>
            </EmptyLink>
            <EmptyLink>
              <span>{t('questions', 'ec', 'amazon', 'aboutAmazon')}</span>
            </EmptyLink>
            <EmptyLink>
              <span>{t('questions', 'ec', 'amazon', 'axe')}</span>
            </EmptyLink>
            <EmptyLink>
              <span>{t('questions', 'ec', 'amazon', 'sustain')}</span>
            </EmptyLink>
            <EmptyLink>
              <span>{t('questions', 'ec', 'amazon', 'press')}</span>
            </EmptyLink>
            <EmptyLink>
              <span>{t('questions', 'ec', 'amazon', 'invest')}</span>
            </EmptyLink>
            <EmptyLink>
              <span>{t('questions', 'ec', 'amazon', 'devices')}</span>
            </EmptyLink>
            <EmptyLink>
              <span>{t('questions', 'ec', 'amazon', 'science')}</span>
            </EmptyLink>
          </div>
          <div className={style.column}>
            <div>{t('questions', 'ec', 'amazon', 'money')}</div>
            <EmptyLink>
              <span>{t('questions', 'ec', 'amazon', 'sellOn')}</span>
            </EmptyLink>
            <EmptyLink>
              <span>{t('questions', 'ec', 'amazon', 'sellApps')}</span>
            </EmptyLink>
            <EmptyLink>
              <span>{t('questions', 'ec', 'amazon', 'supply')}</span>
            </EmptyLink>
            <EmptyLink>
              <span>{t('questions', 'ec', 'amazon', 'protect')}</span>
            </EmptyLink>
            <EmptyLink>
              <span>{t('questions', 'ec', 'amazon', 'affiliate')}</span>
            </EmptyLink>
            <EmptyLink>
              <span>{t('questions', 'ec', 'amazon', 'driver')}</span>
            </EmptyLink>
            <EmptyLink>
              <span>{t('questions', 'ec', 'amazon', 'packageDelivery')}</span>
            </EmptyLink>
            <EmptyLink>
              <span>{t('questions', 'ec', 'amazon', 'advertise')}</span>
            </EmptyLink>
            <EmptyLink>
              <span>{t('questions', 'ec', 'amazon', 'selfPublish')}</span>
            </EmptyLink>
            <EmptyLink>
              <span>{t('questions', 'ec', 'amazon', 'hubPartner')}</span>
            </EmptyLink>
            <EmptyLink>
              <span>{t('questions', 'ec', 'amazon', 'moreWays')}</span>
            </EmptyLink>
          </div>
          <div className={style.column}>
            <div>{t('questions', 'ec', 'amazon', 'payment')}</div>
            <EmptyLink>
              <span>{t('questions', 'ec', 'amazon', 'visa')}</span>
            </EmptyLink>
            <EmptyLink>
              <span>{t('questions', 'ec', 'amazon', 'storeCard')}</span>
            </EmptyLink>
            <EmptyLink>
              <span>{t('questions', 'ec', 'amazon', 'secureCard')}</span>
            </EmptyLink>
            <EmptyLink>
              <span>{t('questions', 'ec', 'amazon', 'businessCard')}</span>
            </EmptyLink>
            <EmptyLink>
              <span>{t('questions', 'ec', 'amazon', 'points')}</span>
            </EmptyLink>
            <EmptyLink>
              <span>{t('questions', 'ec', 'amazon', 'creditCard')}</span>
            </EmptyLink>
            <EmptyLink>
              <span>{t('questions', 'ec', 'amazon', 'reload')}</span>
            </EmptyLink>
            <EmptyLink>
              <span>{t('questions', 'ec', 'amazon', 'giftCards')}</span>
            </EmptyLink>
            <EmptyLink>
              <span>{t('questions', 'ec', 'amazon', 'converter')}</span>
            </EmptyLink>
          </div>
          <div className={style.column}>
            <div>{t('questions', 'ec', 'amazon', 'helpYou')}</div>
            <EmptyLink>
              <span>{t('questions', 'ec', 'amazon', 'yourAccount')}</span>
            </EmptyLink>
            <EmptyLink>
              <span>{t('questions', 'ec', 'amazon', 'yourOrders')}</span>
            </EmptyLink>
            <EmptyLink>
              <span>{t('questions', 'ec', 'amazon', 'shippingRates')}</span>
            </EmptyLink>
            <EmptyLink>
              <span>{t('questions', 'ec', 'amazon', 'prime')}</span>
            </EmptyLink>
            <EmptyLink>
              <span>{t('questions', 'ec', 'amazon', 'replacements')}</span>
            </EmptyLink>
            <EmptyLink>
              <span>{t('questions', 'ec', 'amazon', 'manage')}</span>
            </EmptyLink>
            <EmptyLink>
              <span>{t('questions', 'ec', 'amazon', 'recalls')}</span>
            </EmptyLink>
            <EmptyLink>
              <span>{t('questions', 'ec', 'amazon', 'giftList')}</span>
            </EmptyLink>
            <EmptyLink>
              <span>{t('questions', 'ec', 'amazon', 'help')}</span>
            </EmptyLink>
          </div>
          <div className={style.columnMobile}>
            <EmptyLink>
              <span>{t('questions', 'ec', 'amazon', 'help')}</span>
            </EmptyLink>
            <EmptyLink>
              <span>{t('questions', 'ec', 'amazon', 'amazonCom')}</span>
            </EmptyLink>
            <EmptyLink>
              <span>{t('questions', 'ec', 'amazon', 'yourLists')}</span>
            </EmptyLink>
            <EmptyLink>
              <span>{t('questions', 'ec', 'amazon', 'giftList')}</span>
            </EmptyLink>
            <EmptyLink>
              <span>{t('questions', 'ec', 'amazon', 'yourAccount')}</span>
            </EmptyLink>
            <EmptyLink>
              <span>{t('questions', 'ec', 'amazon', 'sellOnAmazon')}</span>
            </EmptyLink>
            <EmptyLink>
              <span>{t('questions', 'ec', 'amazon', 'recalls')}</span>
            </EmptyLink>
          </div>
          <div className={style.columnMobile}>
            <EmptyLink>
              <span>{t('questions', 'ec', 'amazon', 'customerService')}</span>
            </EmptyLink>
            <EmptyLink>
              <span>{t('questions', 'ec', 'amazon', 'yourOrders')}</span>
            </EmptyLink>
            <EmptyLink>
              <span>{t('questions', 'ec', 'amazon', 'giftCards')}</span>
            </EmptyLink>
            <EmptyLink>
              <span>{t('questions', 'ec', 'amazon', 'findGift')}</span>
            </EmptyLink>
            <EmptyLink>
              <span>{t('questions', 'ec', 'amazon', 'browsing')}</span>
            </EmptyLink>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
